import type { ListaItens, SeletorItem } from '@Lar21/imaginii-web-components/vue'

import type {
  FiltrosCatalogoGrupoDeLocaisDeTrabalho,
  OpcaoGrupoDeLocaisDeTrabalho,
  SelecaoCatalogoGrupoDeLocaisDeTrabalho,
} from '../catalogo-grupo-de-locais-de-trabalho.tipos'

export const CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO =
  'srcNext.governanca.catalogoGrupoDeLocaisDeTrabalho'

type Traduzir = (chave: string) => string

const contemId = (relacoes: unknown, ids: readonly string[]): boolean => Array.isArray(relacoes)
  && relacoes.some((item: unknown) => typeof item === 'object' && item !== null && 'id' in item && typeof item.id === 'string' && ids.includes(item.id))

export const filtrarOpcoesGrupoDeLocaisDeTrabalho = (
  opcoes: readonly OpcaoGrupoDeLocaisDeTrabalho[],
  filtros?: FiltrosCatalogoGrupoDeLocaisDeTrabalho,
  predicado?: (opcao: OpcaoGrupoDeLocaisDeTrabalho) => boolean,
): readonly OpcaoGrupoDeLocaisDeTrabalho[] => {
  if ((!filtros || Object.keys(filtros).length === 0) && !predicado) return opcoes
  return opcoes.filter(opcao => (filtros?.id === undefined || filtros.id.includes(opcao.id))
    && (filtros?.companies === undefined || contemId(opcao.companies, filtros.companies))
    && (filtros?.groups === undefined || contemId(opcao.groups, filtros.groups))
    && (!predicado || predicado(opcao)))
}

const criarItem = (opcao: OpcaoGrupoDeLocaisDeTrabalho): SeletorItem => ({
  chave: opcao.id,
  valor: opcao.name,
})

const selecionadas = (
  valor: SelecaoCatalogoGrupoDeLocaisDeTrabalho,
  multipla: boolean,
): readonly OpcaoGrupoDeLocaisDeTrabalho[] => {
  if (valor === null) return []
  if (!Array.isArray(valor)) return [valor as OpcaoGrupoDeLocaisDeTrabalho]
  if (multipla) return valor as readonly OpcaoGrupoDeLocaisDeTrabalho[]
  const primeira = valor[0] as OpcaoGrupoDeLocaisDeTrabalho | undefined
  return primeira ? [primeira] : []
}

export const criarEstadoSeletorCatalogoGrupoDeLocaisDeTrabalho = (
  opcoes: readonly OpcaoGrupoDeLocaisDeTrabalho[],
  valor: SelecaoCatalogoGrupoDeLocaisDeTrabalho,
  multipla: boolean,
): ListaItens => {
  const carregados = opcoes.filter(opcao => typeof opcao.id === 'string' && Boolean(opcao.id.trim()) && typeof opcao.name === 'string' && Boolean(opcao.name.trim())).map(criarItem)
  const porId = new Map(carregados.map((item) => [String(item.chave), item]))
  return {
    carregados,
    selecionados: selecionadas(valor, multipla).flatMap((opcao) => {
      const item = porId.get(opcao.id)
      return item ? [item] : []
    }),
  }
}

export const extrairValorDoSeletorCatalogoGrupoDeLocaisDeTrabalho = (
  estado: ListaItens,
  opcoes: readonly OpcaoGrupoDeLocaisDeTrabalho[],
  multipla: boolean,
): SelecaoCatalogoGrupoDeLocaisDeTrabalho => {
  const porId = new Map(opcoes.map((opcao) => [opcao.id, opcao]))
  const resultado = [...new Set(
    estado.selecionados.map(({ chave }) => String(chave)),
  )].flatMap((id) => {
    const opcao = porId.get(id)
    return opcao ? [opcao] : []
  })
  return multipla ? resultado : (resultado[0] ?? null)
}

export const criarPropriedadesPontotelSeletorGrupoDeLocaisDeTrabalho = ({
  traduzir, label, placeholder, erro,
}: Readonly<{
  traduzir: Traduzir
  label?: string
  placeholder?: string
  erro: string | null
}>) => ({
  tamanho: 'M' as const,
  largura: '100%',
  tamanhoPagina: 20,
  pesquisavel: true,
  recarregarTodos: true,
  label: label ?? traduzir(`${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.label`),
  placeholder: placeholder ?? traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.placeholder`,
  ),
  erro,
  traducaoNenhumResultado: traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.nenhumResultado`,
  ),
  traducaoSelecionado: traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.selecionado`,
  ),
  traducaoSelecionadosPlural: traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.selecionados`,
  ),
  traducaoRecarregarTodos: traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.recarregar`,
  ),
  traducaoRecarregado: traduzir(
    `${CHAVE_I18N_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO}.recarregado`,
  ),
})
